import { Observable } from "rxjs";

import { CustomerFraudToken } from "./fraud-prevention.model";

export abstract class FraudPreventionService {
	abstract loadScript(): void;

	abstract unloadScript(): void;

	abstract getCustomerFraudToken$(): Observable<CustomerFraudToken | undefined>;

	abstract init(): void;
}
